import React, { useEffect, useState } from 'react';
import { PhoneCall } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget anonymous tap count (no personal data, no cookies).
export const countOfferTap = (location) => {
  try {
    fetch(`${API}/offer-tap`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location }), keepalive: true }).catch(() => {});
  } catch (_) { /* never block the call */ }
};

export const OfferTapsCard = ({ authFetch }) => {
  const [d, setD] = useState(null);
  useEffect(() => { authFetch('get', '/admin/offer-taps').then(({ data }) => setD(data)).catch(() => setD(null)); }, [authFetch]);
  if (!d) return null;
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="offer-taps-card">
      <div className="flex items-center gap-2"><PhoneCall className="w-4 h-4 text-[color:var(--mv-orange)]" /><h2 className="font-display font-black text-[color:var(--mv-navy)]">“Call to book & save 10%” taps</h2></div>
      {[['Today', d.today, 'today'], ['Last 7 days', d.last_7_days, '7d'], ['Last 30 days', d.last_30_days, '30d']].map(([l, v, k]) => (
        <div key={k} className="text-sm"><span className="text-slate-500">{l}</span> <strong className="text-[color:var(--mv-navy)] text-lg" data-testid={`offer-taps-${k}`}>{v}</strong></div>
      ))}
      <div className="text-xs text-slate-500">Homepage {d.by_location?.hero || 0} · Quote result {d.by_location?.['quote-result'] || 0} (30 days). Counts taps, not completed calls.</div>
    </section>
  );
};
